module.exports = __webpack_public_path__ + "img/mariage-4-lazy.41755009.jpg";